import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { Grid, Image, Form, Button, Header } from 'semantic-ui-react';
import logo from 'images/loginLogo.png';

const propTypes = {
  handleChange: PropTypes.func.isRequired,
  passwordChangeAction: PropTypes.func.isRequired,
  skipAction: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired
};

const defaultProps = {
};

class PasswordForm extends Component {
  handleEntSubmit = (e) => {
    if (e.key === 'Enter') {
      const { passwordChangeAction } = this.props;
      passwordChangeAction();
    }
  }

  render() {
    const { handleChange, skipAction, passwordChangeAction, type } = this.props;
    const recommend = 'RECOMMEND'; // other 'FORCE'
    let classes = '';
    if (type === recommend) {
      classes = ' form-recommend';
    }

    return (
      <Grid
        className="login-form center"
        textAlign="center"
        verticalAlign="middle"
      >
        <Grid.Column
          className={`login-form-col${classes}`}
        >
          <Header
            className="center"
            textAlign="center"
          >
            <Image
              src={logo}
            />
            <div>
              {(type === recommend)
                ? (
                  <Fragment>
                    <p className="pwd-recommend">비밀번호 생성 후 180일이 경과하였습니다.</p>
                  </Fragment>
                )
                : null}
              <p className="pwd-recommend">보안 강화를 위해</p>
              <p className="pwd-recommend">새로운 비밀번호를 설정해 주세요</p>
            </div>
          </Header>
          <Form size="large">
            <Form.Input
              className="form-input"
              fluid
              label="새로운 비밀번호 입력"
              placeholder="비밀번호 입력"
              type="password"
              autoFocus
              onChange={(e) => { handleChange(e.target.value, 'password'); }}
            />
            <Form.Input
              className="form-input"
              fluid
              placeholder="비밀번호 재입력"
              type="password"
              onChange={(e) => { handleChange(e.target.value, 'rePassword'); }}
              onKeyPress={this.handleEntSubmit}
            />
            <div className="password-desc">
              <p>영문대소문자, 숫자, 특수문자를 최소 각 1자씩</p>
              <p>사용하여, 8~20자를 입력해주세요.</p>
            </div>
            {(type === recommend)
              ? (
                <Button
                  className="skip"
                  type="button"
                  fluid
                  size="large"
                  onClick={skipAction}
                >
                30일 후 변경하기
                </Button>
              )
              : null}
            <Button
              type="button"
              color="green"
              fluid
              size="large"
              onClick={passwordChangeAction}
            >
변경하기
            </Button>
            <p>
              고객센터 1644-5047
            </p>
          </Form>
        </Grid.Column>

      </Grid>
    );
  }
}

PasswordForm.propTypes = propTypes;
PasswordForm.defaultProps = defaultProps;

export default PasswordForm;
